import { gql } from "@apollo/client";

export const GetLocation = gql`
  query GetLocation($id: String!) {
    locationOne(id: $id) {
      address
      city
      createdDate
      id
      description
      stationsEnabled
      notificationSenderNumber
      transactionProcessTime
      locationServices {
        id
        organizationService {
          name
        }
      }
      logoUrl
      name
      zip
      timezone
      organization {
        id
        name
      }
      state
      primaryContact {
        firstName
        lastName
        email
        phoneNumber
      }
      passportLocCode
    }
  }
`;

export const GetLocations = gql`
  query GetLocations {
    locationMany {
      id
      name
    }
  }
`;

export const GetLocationPage = gql`
  query GetLocationPage($pagination: PaginationInput!) {
    locationPage(pagination: $pagination) {
      items {
        id
        name
        logoUrl
        address
        createdDate
      }
      totalRows
    }
  }
`;

export const GetLocationDetailCalendar = gql`
  query GetLocationDetailCalendar($id: String!) {
    locationOne(id: $id) {
      id
      employees {
        id
        user {
          firstName
          lastName
        }
      }
      rooms {
        id
        name
      }
      locationServices {
        id
        organizationService {
          name
        }
      }
    }
  }
`;

export const GetLocationRevenue = gql`
  query GetLocationRevenue($id: String!) {
    locationOne(id: $id) {
      id
      locationRevenue {
        id
        payrocAccount {
          id
          merchantId
          payrocVirtualTerminalId
          payrocEmbeddedSecret
        }
      }
    }
  }
`;

export const GetLocationRooms = gql`
  query GetLocationRooms {
    locationMany {
      id
      name
      rooms {
        id
        name
      }
    }
  }
`;
